import React, { useEffect, useState } from 'react'
import { EditarTipoEntrega, OpcaoEntrega } from "./EditarTipoEntrega";
import { TipoEntrega } from "../AbaTipoEntrega";
import { Breadcrumb2Container } from "../../../breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "../../../renderizarOuRemoverComponentReact";
import { TelaEntregaContainer } from "../../TelaEntregaContainer";
import globalMU from "../../../../../globalMU";
import { tratamentoErroPadrao } from "../../../../use-cases";
import microuniversoApi from "../../../../api/microuniversoApi";
import { useAppSelector } from "../../../../redux/hooks";
import { gravarTelasAlteradasSalvaAction } from 'app/redux/telaOrcamentoAlteradaNaoSalvaSlice';
import store from 'app/redux/store/store';

export type EditarTipoEntregaContainerProps = {
  tipoEntrega: TipoEntrega
  mostrarNomeComoCodigo: boolean
}

export const EditarTipoEntregaContainer = (props: EditarTipoEntregaContainerProps) => {
  const [opcoes, setOpcoes] = useState<OpcaoEntrega[]>([])
  const orcamento = useAppSelector(state => state.orcamento)
  const obterOpcoes = async () => {
    try {
      globalMU.blockUI({ tryPassiveLoading: true })
      const dados = await microuniversoApi.Orcamento.ObterOpcoesEntrega()
      setOpcoes(dados.OpcoesEntrega)
    }
    catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      globalMU.unblockUI()
    }
  }
  const aplicar = async (dados: TipoEntrega) => {
    try {
      globalMU.blockUI({ tryPassiveLoading: true })
      const response = await microuniversoApi.Orcamento.definirTipoEntrega(orcamento.IdentificadorOrcamento, dados)
      if (!("Error" in response)) {
        globalMU.showSuccessMessage('Tipo de entrega alterado com sucesso.')
        store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_tipoEntrega"))
        renderizarComponentReact(
          <TelaEntregaContainer telaDefault="Tipo Entrega" />,
          "conteudo-pagina",
          true
        )
      }
    }
    catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      globalMU.unblockUI()
    }
  }

  useEffect(() => {
    obterOpcoes()
  }, [])
  return <>
    <Breadcrumb2Container
      passos={["Entrega", "Editar Tipo Entrega"]}
      exibirBotaoLimpar={false}
      id="breadcrumb-tela-entrega-editar-tipo-entrega"
      exibirBotaoVoltar
      onPassoSelecionado={(passo) => {
        if (passo === "Entrega") {
          renderizarComponentReact(
            <TelaEntregaContainer telaDefault="Tipo Entrega" />,
            "conteudo-pagina",
            true
          )
        }
      }}
      onBotaoVoltarClicado={() => renderizarComponentReact(
        <TelaEntregaContainer telaDefault="Tipo Entrega" />,
        "conteudo-pagina",
        true
      )}
    />
    <EditarTipoEntrega
      mostrarNomeComoCodigo={props.mostrarNomeComoCodigo}
      somenteLeitura={orcamento.SomenteLeitura}
      tipoEntrega={props.tipoEntrega}
      opcoesEntrega={opcoes}
      onAplicarTipoEntrega={aplicar}
    />
  </>
}
